(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["sidebar-cat"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function() {
    // 現在のページの完全なURLを取得
    const currentUrl = window.location.href;
    
    // リンク要素を取得
    const allLink = document.getElementById('filter-link-all');
    const inStockLink = document.getElementById('filter-link-instock');

    // URLに在庫フィルターのパラメータが含まれているかチェック
    if (currentUrl.includes('filter.v.availability=1')) {
      // 在庫ありフィルターが有効な場合
      if (inStockLink) {
        inStockLink.classList.add('is-active');
      }
    } else {
      // フィルターがない場合（「すべて」の状態）
      if (allLink) {
        allLink.classList.add('is-active');
      }
    }
  });
  } catch(e) { console.error(e); }
})();

})();
